<template>
    <b-form ref="form" :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData">
        <div class="row">
            <div class="col-6">
                <file-input class="c-file-input" ref="file" @input="clearFile" label="Banner Image*"
                            v-model="model.banner_image"
                            :disabled="loading" name="Banner Image">
                    <template #append>
                        <div class="btn-group">
                            <btn v-if="initialData.banner_image"
                                 @click="viewFile(initialData.banner_image)"
                                 type="button" class="fa fa-eye" size="xs"/>
                        </div>
                    </template>
                </file-input>
            </div>

            <div class="col-6">
                <validated-input type="number" label="Order" v-model="model.order"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-input label="Banner Text 1*" name="Banner Text 1" v-model="model.banner_text_1"
                                 :rules="{required: true, max:25}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-input label="Banner Text 2*" name="Banner Text 2" v-model="model.banner_text_2"
                                 :rules="{required: true, max:30}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-input label="Banner Text 3*" name="Banner Text 3" v-model="model.banner_text_3"
                                 :rules="{required: true, max:70}" :disabled="loading"/>
            </div>

            <div class="col-6">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                    :rules="{required: false}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <btn class="trn" text="Update" loading-text="Updating..." size="sm" :disabled="loading"
                     :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'EditBanner',

    props : { initialData : { type : Object } },

    data () {
        return {
            addUrl : urls.cms.banner.addEdit
        };
    },

    methods : {
        clearFile (file) {
            this.initialData.banner_image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            this.$notify('Successfully Updated Banner..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
